'use strict';

require('styles/templates/article/article.behind-the-lens.scss');

var _ExploreBySeries = require('../components/ExploreBySeries');

var _ExploreBySeries2 = _interopRequireDefault(_ExploreBySeries);

var _BlogMenu = require('../components/BlogMenu');

var _BlogMenu2 = _interopRequireDefault(_BlogMenu);

var _Shogun = require('../components/Shogun');

var _Shogun2 = _interopRequireDefault(_Shogun);

var _QuickView = require('../components/QuickView');

var _QuickView2 = _interopRequireDefault(_QuickView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
  _ExploreBySeries2.default.init();
  _BlogMenu2.default.bindActions();
  _Shogun2.default.init();
  _QuickView2.default.init();
});

window.addEventListener('load', function () {});